enum LanguageEnum {
	Dutch = 'nl',
	German = 'de',
	English = 'en',
}

export default LanguageEnum;
